import Numeral from 'numeral';
Numeral.register('locale', 'id', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'Jt',
    billion: 'M',
    trillion: 'T',
  },
  currency: {
    symbol: 'Rp.',
  },
});
